import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Category} from "../../models/category";

import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {User} from "../../models";
import {first} from "rxjs/operators";
import {UserService} from "../../services";
import {Card} from "../../models/card";
import {Service} from "../../models/service";
import {ServiceService} from "../../services/service.service";
import {VirtualReceipt} from "../../pos/model/virtualReceipt";

@Component({
    selector: 'open-bill-exists-dialog',
    templateUrl: './openBillExists.component.html',
    styleUrls: ['./openBillExists.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class OpenBillDialogComponent {
    action: string;
    customer: User;
    dialogTitle: string;
    dialogRef: any;
    card: Card;
    form: FormGroup;
    virtualReceipt: VirtualReceipt;

    constructor(
        public matDialogRef: MatDialogRef<OpenBillDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
        private userService: UserService,
        private formBuilder: FormBuilder,
        private serviceService: ServiceService,
    ) {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults
        this.action = _data.action;
        this.virtualReceipt = _data.virtualReceipt;

    }


}
